import { render } from "./change-password.vue?vue&type=template&id=29d0bc94&scoped=true"
import script from "./change-password.vue?vue&type=script&lang=js"
export * from "./change-password.vue?vue&type=script&lang=js"

import "./change-password.vue?vue&type=style&index=0&id=29d0bc94&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d0bc94"]])

export default __exports__